import RecipeConfidenceEngine from './RecipeConfidenceEngine';

export default function App() {
  return <RecipeConfidenceEngine />;
}
